module.exports = __webpack_public_path__ + "img/banner33.adb3650d.jpg";